import React from "react";
import {Col, Container, Row, media} from 'styled-bootstrap-grid';
import styled from "styled-components";
import {useInView} from "react-intersection-observer";
import {Transition} from "react-transition-group";
import {Link} from "react-router-dom";
import PrimaryButton from "../../Button/components/PrimaryButton";

const GetInTouchWrapper = styled.div`
  background: #F4F6F8;
  padding: 6rem 0;
  border-top: ${({useBorderTop}) => (useBorderTop ? '1px solid #e5e5e5' : 'none')};
`;

const Title = styled.h4`
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  transition: all .25s ease;
  text-align: center;

   ${media.lg`
    text-align: left;
  `}

  ${(props) => props.state === 'entering' && `
    transform: translateY(1rem);
    opacity: 0;
  `}
  ${(props) => props.state === 'entered' && `
    transform: translateY(0);
    opacity: 1;
  `}
  ${(props) => props.state === 'exiting' && `
    transform: translateY(0);
    opacity: 1;
  `}
  ${(props) => props.state === 'exited' && `
    transform: translateY(1rem);
    opacity: 0;
  `}
`;

const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;

    ${media.lg`
    justify-content: flex-end;
  `}
`;

const P = styled.div`
  font-size: 2.5rem;
  line-height: 3.5rem;
  font-weight: 400;
  transition: all .25s ease;
  text-align: center;

   ${media.lg`
    text-align: left;
  `}

  ${(props) => props.state === 'entering' && `
    transform: translateY(-2rem);
    opacity: 0;
  `}
  ${(props) => props.state === 'entered' && `
    transform: translateY(0);
    opacity: 1;
  `}
  ${(props) => props.state === 'exiting' && `
    transform: translateY(0);
    opacity: 1;
  `}
  ${(props) => props.state === 'exited' && `
    transform: translateY(-2rem);
    opacity: 0;
  `}
`;

// const StyledButton = styled.button`
//   height: 3rem;
//   margin-top: 2rem;
//   padding: 0 2rem;
//   background: none;
//   border-radius: 2rem;
//   border: 1px solid #e5e5e5;
//   text-decoration: none;
//   min-width: 10rem;
//   outline: 0;
//   cursor: pointer;
//   transition: all ease 0.25s;
//   color: #000;

//   :hover {
//     background: #635bff;
//     color: #fff;
//     border-color: #635bff;
//     box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
//     svg {
//       fill: #fff;
//     }
//   }

//     ${media.lg`
//     margin-top: 0;
//   `}
// `;

// const StyledP = styled.p`
//   display: inline-block;
//   margin: 0 0.6rem;
//   font-size: 0.8rem;
//   font-weight: 600;
//   letter-spacing: 0.2rem;
//   text-transform: uppercase;
// `;

// const StyledSvg = styled.svg`
//   width: 1rem;
//   transition: all ease 0.25s;
// `;

const GetInTouch = ({title, text, buttonText, /* useArrow,*/ useBorderTop, to = "/contact"}) => {
  /** different values 'ref', 'inView' for each animation block to work correctly */
  const [refTitle, inViewTitle] = useInView();
  const [refText, inViewText] = useInView();

  return (
    <GetInTouchWrapper useBorderTop={useBorderTop}>
      <Container>
        <Row>
          <Col col={12} lg={9}>
            <Transition appear={true}
                        in={inViewTitle}
                        timeout={250}
            >
              {(state) => (
                <Title state={state} ref={refTitle}>{title}</Title>
              )}
            </Transition>
            <Transition appear={true}
                        in={inViewText}
                        timeout={250}
            >
              {(state) => (
                <P state={state} ref={refText}>
                  {text}
                </P>
              )}
            </Transition>
          </Col>
          <StyledCol col={12} lg={3}>
            <Link to={to}>
              <PrimaryButton buttonText={buttonText}/>
            </Link>
          </StyledCol>
        </Row>
      </Container>
    </GetInTouchWrapper>
  );
};

export default GetInTouch;
